import React, { useEffect, useRef, useState, useMemo, useCallback } from 'react';
import AppNav from './AppNav';
import NigeriaMap from './NigeriaMap';
import { useRipple } from '../hooks/useRipple';
import { fetchLivePrices } from '../Livepriceservice';
import './styles/clickEffects.css';

/* ═══════════════════════════════════════════════════
   COMMODITY DATA
═══════════════════════════════════════════════════ */
const ALL_COMMODITIES = [
  { name:'Bananas',                     mape:3.95,  base:4500,   unit:'/kg',    trend:-1, cat:'Produce'  },
  { name:'Beans (red)',                 mape:5.02,  base:95000,  unit:'/50kg',  trend: 1, cat:'Legumes'  },
  { name:'Beans (white)',               mape:4.45,  base:98400,  unit:'/50kg',  trend:-1, cat:'Legumes'  },
  { name:'Bread',                       mape:3.25,  base:2500,   unit:'/loaf',  trend: 1, cat:'Staples'  },
  { name:'Cassava meal (gari, yellow)', mape:13.79, base:28750,  unit:'/50kg',  trend:-1, cat:'Tubers'   },
  { name:'Cowpeas',                     mape:10.16, base:92000,  unit:'/50kg',  trend: 1, cat:'Legumes'  },
  { name:'Eggs',                        mape:2.36,  base:8500,   unit:'/crate', trend:-1, cat:'Protein'  },
  { name:'Fish',                        mape:9.08,  base:45000,  unit:'/kg',    trend: 1, cat:'Protein'  },
  { name:'Fuel (diesel)',               mape:2.88,  base:1100,   unit:'/litre', trend:-1, cat:'Fuel'     },
  { name:'Fuel (petrol-gasoline)',      mape:2.39,  base:950,    unit:'/litre', trend:-1, cat:'Fuel'     },
  { name:'Groundnuts',                  mape:15.11, base:55000,  unit:'/50kg',  trend: 1, cat:'Legumes'  },
  { name:'Maize',                       mape:13.64, base:42800,  unit:'/50kg',  trend:-1, cat:'Grains'   },
  { name:'Maize flour',                 mape:4.93,  base:38000,  unit:'/50kg',  trend: 1, cat:'Grains'   },
  { name:'Meat (beef)',                 mape:3.91,  base:55000,  unit:'/kg',    trend: 1, cat:'Protein'  },
  { name:'Meat (goat)',                 mape:3.69,  base:62000,  unit:'/kg',    trend:-1, cat:'Protein'  },
  { name:'Milk (powder)',               mape:6.79,  base:18000,  unit:'/kg',    trend: 1, cat:'Protein'  },
  { name:'Millet',                      mape:9.75,  base:18500,  unit:'/50kg',  trend:-1, cat:'Grains'   },
  { name:'Oil (palm)',                  mape:3.99,  base:24500,  unit:'/litre', trend: 1, cat:'Staples'  },
  { name:'Oil (vegetable)',             mape:2.68,  base:32000,  unit:'/litre', trend:-1, cat:'Staples'  },
  { name:'Onions',                      mape:4.67,  base:5500,   unit:'/kg',    trend: 1, cat:'Produce'  },
  { name:'Oranges',                     mape:6.59,  base:3800,   unit:'/kg',    trend:-1, cat:'Produce'  },
  { name:'Rice (imported)',             mape:7.38,  base:95000,  unit:'/50kg',  trend: 1, cat:'Grains'   },
  { name:'Rice (milled, local)',        mape:12.2,  base:64120,  unit:'/50kg',  trend:-1, cat:'Grains'   },
  { name:'Salt',                        mape:5.59,  base:1200,   unit:'/kg',    trend: 1, cat:'Staples'  },
  { name:'Sorghum',                     mape:11.28, base:38200,  unit:'/50kg',  trend:-1, cat:'Grains'   },
  { name:'Spinach',                     mape:9.89,  base:2800,   unit:'/bunch', trend: 1, cat:'Produce'  },
  { name:'Sugar',                       mape:3.19,  base:12000,  unit:'/kg',    trend:-1, cat:'Staples'  },
  { name:'Tomatoes',                    mape:6.26,  base:3500,   unit:'/kg',    trend:-1, cat:'Produce'  },
  { name:'Watermelons',                 mape:6.23,  base:3000,   unit:'/kg',    trend: 1, cat:'Produce'  },
  { name:'Yam',                         mape:16.88, base:5130,   unit:'/tuber', trend: 1, cat:'Tubers'   },
];

const CATS = ['All','Grains','Legumes','Tubers','Protein','Produce','Staples','Fuel'];

const PHOTOS = {
  'Bananas':                     'https://images.unsplash.com/photo-1603833665858-e61d17a86224?w=120&q=70',
  'Beans (red)':                 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSpmE0L5bTiyYltnoNnLpmUr-67YiVCje3DZg&s',
  'Beans (white)':               'https://i0.wp.com/www.africopanigeria.com/wp-content/uploads/2021/02/Pure-white-beans.png?fit=600%2C600&ssl=1',
  'Bread':                       'https://images.unsplash.com/photo-1509440159596-0249088772ff?w=120&q=70',
  'Cassava meal (gari, yellow)': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJuaMUZ8WoYR9SsrYV698swMeIicWiUwY4dg&s',
  'Cowpeas':                     'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQxhU8obh3-z5MqZH1R4KT1-_jyfJ6yzsE1AA&s',
  'Eggs':                        'https://images.unsplash.com/photo-1582722872445-44dc5f7e3c8f?w=120&q=70',
  'Fish':                        'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSuTuO7vC9ADgBrMJc_eBufJZJTo0fa8nMSZw&s',
  'Fuel (diesel)':               'https://5.imimg.com/data5/DX/LI/CY/ANDROID-46302579/product-jpeg-500x500.jpg',
  'Fuel (petrol-gasoline)':      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTue-iBfUj5T6PnKMXO1IM2P9TSmYdDJ5Sgxg&s',
  'Groundnuts':                  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTutUfAvTJRos_uo1MOPUM1ekNZikDupb49Vg&s',
  'Maize':                       'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSEPGaAsYQc-OLxMUtc_P7oIy3EctP-Z0vOAw&s',
  'Maize flour':                 'https://cdn.tridge.com/attachment-file/69/3b/aa/693baae4cf68421c6e2ef1d54a311dc488ce028d/Maize_Flour.jpg',
  'Meat (beef)':                 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTogkXgjJVKOAKOXt1PSGR9oqVmByNjFkzVGA&s',
  'Meat (goat)':                 'https://yourfreshbox.in/wp-content/uploads/2021/11/mut-shoulder-front.jpg',
  'Milk (powder)':               'https://images.ctfassets.net/yzlb24ni1fxz/6BAaNAV376srY8MAPPReoC/3d41288a1691d5d4e0f0ecc68c71b15b/Lactorich_Vers_links_image_square.jpg',
  'Millet':                      'https://img.freepik.com/free-photo/raw-organic-healthy-millet_114579-9027.jpg?semt=ais_hybrid&w=740&q=80',
  'Oil (palm)':                  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTAnQc2finQTy-tMJZODLITcpgM-ZcPtaM60A&s',
  'Oil (vegetable)':             'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQVsNnJa_rFZXD7QU_nyfZkxzTzPolWfrH2lg&s',
  'Onions':                      'https://images.unsplash.com/photo-1508747703725-719777637510?w=120&q=70',
  'Oranges':                     'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS5bCYpYSse-rEyqEN84lh7HCbmckMQylw4kw&s',
  'Rice (imported)':             'https://img.freepik.com/premium-photo/rice-bag-white-background_269543-952.jpg?semt=ais_hybrid&w=740&q=80',
  'Rice (milled, local)':        'https://img.freepik.com/premium-photo/rice-bag-white-background_269543-952.jpg?semt=ais_hybrid&w=740&q=80',
  'Salt':                        'https://i0.wp.com/media.globalnews.ca/videostatic/1017/31/GN160426VOOSHY.jpg?w=1040&quality=70&strip=all',
  'Sorghum':                     'https://www.eatthis.com/wp-content/uploads/sites/4/2022/11/sorghum-grain-bowl.jpg?quality=82&strip=all',
  'Spinach':                     'https://images.unsplash.com/photo-1576045057995-568f588f82fb?w=120&q=70',
  'Sugar':                       'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTACBYcMHhXRm4P1jW8f5zxtFeCQbXuPWdxaQ&s',
  'Tomatoes':                    'https://upload.wikimedia.org/wikipedia/commons/8/89/Tomato_je.jpg',
  'Watermelons':                 'https://images.unsplash.com/photo-1587049352846-4a222e784d38?w=120&q=70',
  'Yam':                         'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQz303YgCs0VC6gZvdI2ucO7g9ZruqM05J3PA&s',
};

/* ═══════════════════════════════════════════════════
   HOOKS
═══════════════════════════════════════════════════ */
function useIsMobile(bp = 1024) {
  const [v, setV] = useState(() => window.innerWidth <= bp);
  useEffect(() => {
    const h = () => setV(window.innerWidth <= bp);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, [bp]);
  return v;
}

function useLivePrices() {
  const [prices, setPrices] = useState(() => {
    const o = {};
    ALL_COMMODITIES.forEach(c => { o[c.name] = { price: c.base, pct: '0.00', falling: c.trend === -1 }; });
    return o;
  });
  useEffect(() => {
    const id = setInterval(() => {
      setPrices(prev => {
        const next = { ...prev };
        ALL_COMMODITIES.forEach(c => {
          const noise = (Math.random() - 0.48) * c.base * Math.min(0.055, c.mape / 100) * c.trend;
          const np  = Math.max(c.base * 0.82, Math.min(c.base * 1.18, prev[c.name].price + noise));
          const pct = ((np - c.base) / c.base * 100).toFixed(2);
          next[c.name] = { price: Math.round(np), pct, falling: parseFloat(pct) < 0 };
        });
        return next;
      });
    }, 3000);
    return () => clearInterval(id);
  }, []);
  return prices;
}

function useAnimatedCount(target, duration = 1400) {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      let start = null;
      const step = ts => {
        if (!start) start = ts;
        const p = Math.min((ts - start) / duration, 1);
        setVal(Math.floor(p * target));
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
      io.disconnect();
    }, { threshold: 0.3 });
    if (ref.current) io.observe(ref.current);
    return () => io.disconnect();
  }, [target, duration]);
  return [val, ref];
}

/* ═══════════════════════════════════════════════════
   OHLC GENERATOR
   Generates daily candles from PRED_START_DATE all the
   way to TODAY so the chart always ends at the current date.
═══════════════════════════════════════════════════ */
const PRED_START_DATE = '2024-09-01';
 
function genOHLC(base = 42800) {
  const start = new Date(PRED_START_DATE);
  const today = new Date();
  const days  = Math.max(90, Math.ceil((today - start) / 86400000) + 3);
  let p = base;
  return Array.from({ length: days }, (_, i) => {
    const d = new Date(start);
    d.setDate(d.getDate() + i);
 
    // Small realistic daily body drift: ±0.8% max
    const drift = (Math.random() - 0.49) * 0.016;
    const open  = p;
    const close = Math.round(open * (1 + drift));
 
    // Wicks: small FIXED % of price — NOT a multiple of the body size
    // This prevents the wick from towering over the body when body ≈ 0
    const wickPct = 0.003 + Math.random() * 0.003; // 0.3% – 0.6%
    const high  = Math.round(Math.max(open, close) * (1 + wickPct));
    const low   = Math.round(Math.min(open, close) * (1 - wickPct));
 
    p = Math.max(base * 0.85, Math.min(base * 1.15, close));
    return {
      date:   d.toISOString().slice(0, 10),
      open,
      high:   Math.min(high, base * 1.16),
      low:    Math.max(low,  base * 0.84),
      close:  p,
      volume: Math.round(100000 + Math.random() * 400000),
      isPrediction: true,
    };
  });
}

const fmt  = n => `₦${Number(n).toLocaleString('en-NG')}`;
const fmtS = s => new Date(s).toLocaleDateString('en-GB', { day:'2-digit', month:'short' });

/* ═══════════════════════════════════════════════════
   INTERACTIVE CANDLESTICK CHART  — fixed axis overlap
   KEY FIX: candles draw within (chartW - AXIS_W) so they
   never overlap the right-side price labels.
═══════════════════════════════════════════════════ */
function InteractiveCandlestick({ commodity = 'Maize', unit = '/50kg', basePrice = 42800, isLiveMode = false }) {
  const containerRef = useRef(null);
  const [chartW, setChartW] = useState(500);
  const CHART_H = 240, VOL_H = 52, PAD = { top:16, bottom:22, left:0, right:0 };
  const AXIS_W = 48; // reserved for right-side price labels — candles must NOT enter this zone
 
  const baseData = useMemo(() => genOHLC(basePrice), [basePrice]);
 
  const [liveCandles, setLiveCandles] = useState([]);
  const liveRef = useRef(liveCandles);
  liveRef.current = liveCandles;
 
  useEffect(() => {
    if (!isLiveMode) { setLiveCandles([]); return; }
    const interval = setInterval(() => {
      const all  = [...baseData, ...liveRef.current];
      const last = all[all.length - 1];
      const drift   = (Math.random() - 0.49) * 0.016;
      const open    = last.close;
      const close   = Math.round(open * (1 + drift));
      const wickPct = 0.003 + Math.random() * 0.003;
      const high    = Math.round(Math.max(open, close) * (1 + wickPct));
      const low     = Math.round(Math.min(open, close) * (1 - wickPct));
      const d     = new Date(last.date);
      d.setDate(d.getDate() + 1);
      setLiveCandles(prev => [...prev, {
        date: d.toISOString().slice(0, 10),
        open, high, low, close,
        volume: Math.round(100000 + Math.random() * 400000),
        isLive: true,
      }]);
    }, 3000);
    return () => clearInterval(interval);
  }, [isLiveMode, baseData]);
 
  const allData = useMemo(() => [...baseData, ...liveCandles], [baseData, liveCandles]);
 
  // The drawable width for candles — leaves room for the axis on the right
  const candleAreaW = Math.max(chartW - AXIS_W, 100);
 
  const VISIBLE = Math.max(20, Math.floor(candleAreaW / 10));
  const [offsetIdx, setOffsetIdx] = useState(null);
  const maxOffset = allData.length - 1;
  const minOffset = VISIBLE - 1;
 
  useEffect(() => { setOffsetIdx(maxOffset); }, [maxOffset]);
  useEffect(() => {
    if (isLiveMode && liveCandles.length > 0) setOffsetIdx(maxOffset);
  }, [isLiveMode, liveCandles.length, maxOffset]);
 
  const effectiveOffset = offsetIdx !== null ? Math.max(minOffset, Math.min(maxOffset, offsetIdx)) : maxOffset;
  const rightIdx = effectiveOffset;
  const leftIdx  = Math.max(0, rightIdx - VISIBLE + 1);
  const visData  = allData.slice(leftIdx, rightIdx + 1);
 
  const prices = visData.flatMap(d => [d.high, d.low]);
  const minP   = prices.length ? Math.min(...prices) : basePrice * 0.9;
  const maxP   = prices.length ? Math.max(...prices) : basePrice * 1.1;
  const prng   = maxP - minP || 1;
  const padP   = prng * 0.08;
  const cH     = CHART_H - PAD.top - PAD.bottom;
  const toY    = useCallback(p => PAD.top + cH - ((p - (minP - padP)) / (prng + padP * 2)) * cH, [minP, prng, padP, cH]);
 
  // slot and candle width are based on candleAreaW, not full chartW
  const slot   = candleAreaW / Math.max(visData.length, 1);
  const cw     = Math.max(2, Math.min(slot * 0.62, 14));
 
  const [hover, setHover] = useState(null);
  const dragRef  = useRef(null);
  const touchRef = useRef(null);
 
  const handleMouseDown = useCallback(e => {
    dragRef.current = { startX: e.clientX, startOff: effectiveOffset };
  }, [effectiveOffset]);
 
  const handleMouseMove = useCallback(e => {
    if (!dragRef.current) {
      const rect = e.currentTarget.getBoundingClientRect();
      const mx   = e.clientX - rect.left;
      // Only register hover in the candle area, not the axis area
      if (mx > candleAreaW) { setHover(null); return; }
      const idx  = Math.max(0, Math.min(visData.length - 1, Math.floor(mx / slot)));
      setHover({ idx, candle: visData[idx], x: (idx + 0.5) * slot });
      return;
    }
    const dx       = dragRef.current.startX - e.clientX;
    const dCandles = Math.round(dx / slot);
    const newOff   = Math.max(minOffset, Math.min(maxOffset, dragRef.current.startOff + dCandles));
    setOffsetIdx(newOff);
  }, [visData, slot, minOffset, maxOffset, candleAreaW]);
 
  const handleMouseUp  = useCallback(() => { dragRef.current = null; }, []);
  const handleLeave    = useCallback(() => { setHover(null); dragRef.current = null; }, []);
 
  const handleTouchStart = useCallback(e => {
    touchRef.current = { startX: e.touches[0].clientX, startOff: effectiveOffset };
  }, [effectiveOffset]);
 
  const handleTouchMove = useCallback(e => {
    if (!touchRef.current) return;
    const dx       = touchRef.current.startX - e.touches[0].clientX;
    const dCandles = Math.round(dx / slot);
    setOffsetIdx(Math.max(minOffset, Math.min(maxOffset, touchRef.current.startOff + dCandles)));
  }, [slot, minOffset, maxOffset]);
 
  const gridCount = 5;
  const gridLines = Array.from({ length: gridCount + 1 }, (_, i) => ({
    y:     toY((minP - padP) + ((prng + padP * 2) * i / gridCount)),
    price: (minP - padP) + ((prng + padP * 2) * i / gridCount),
  }));
 
  const maxVol = Math.max(...visData.map(d => d.volume || 1), 1);
 
  useEffect(() => {
    if (!containerRef.current) return;
    const ro = new ResizeObserver(([e]) => setChartW(e.contentRect.width));
    ro.observe(containerRef.current);
    return () => ro.disconnect();
  }, []);
 
  const latest = allData[allData.length - 1] || baseData[baseData.length - 1];
  const prev   = allData[allData.length - 2] || latest;
  const chg    = latest.close - prev.close;
  const chgPct = ((chg / (prev.close || 1)) * 100).toFixed(2);
  const bull   = chg >= 0;
  const atLeftEdge  = leftIdx === 0;
  const atRightEdge = rightIdx === maxOffset;
 
  return (
    <div style={{ background:'#fff', border:'1px solid #e5e7eb', borderTop:'3px solid #d4a017', borderRadius:12, overflow:'hidden', boxShadow:'0 2px 16px rgba(0,0,0,0.06)', width:'100%' }}>
 
      {/* Header */}
      <div style={{ padding:'10px 14px 8px', borderBottom:'1px solid #f3f4f6' }}>
        <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', gap:8, flexWrap:'wrap' }}>
          <div>
            <div style={{ fontSize:9, color:'#6b7280', letterSpacing:2, textTransform:'uppercase', marginBottom:1, fontFamily:"'IBM Plex Mono',monospace" }}>
              Agricultural · NGX AGRI
            </div>
            <div style={{ fontSize:16, fontWeight:800, color:'#111827', fontFamily:"'Syne',sans-serif" }}>
              {commodity} <span style={{ fontSize:10, fontWeight:400, color:'#9ca3af' }}>{unit}</span>
            </div>
          </div>
          <div style={{ textAlign:'right' }}>
            <div style={{ fontSize:20, fontWeight:700, color:'#d4a017', fontFamily:"'IBM Plex Mono',monospace", letterSpacing:-1 }}>{fmt(latest.close)}</div>
            <span style={{ background:bull?'#dcfce7':'#fee2e2', color:bull?'#15803d':'#b91c1c', fontSize:10, fontWeight:600, padding:'2px 7px', borderRadius:20, fontFamily:"'IBM Plex Mono',monospace" }}>
              {bull?'▲':'▼'} {bull?'+':''}{fmt(chg)} ({bull?'+':''}{chgPct}%)
            </span>
          </div>
        </div>
 
        {/* Mode + Nav controls */}
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:8, gap:8, flexWrap:'wrap' }}>
          <div style={{ display:'flex', alignItems:'center', gap:6 }}>
            <span style={{ fontSize:9, color:'#9ca3af', fontFamily:"'IBM Plex Mono',monospace", textTransform:'uppercase', letterSpacing:1 }}>Mode:</span>
            <span style={{ fontSize:9, fontWeight:700, padding:'2px 8px', borderRadius:20,
              background: isLiveMode ? '#dcfce7' : '#f1f5f9',
              color: isLiveMode ? '#15803d' : '#64748b',
              fontFamily:"'IBM Plex Mono',monospace",
              display:'flex', alignItems:'center', gap:4,
            }}>
              {isLiveMode && <span style={{ width:5, height:5, borderRadius:'50%', background:'#22c55e', display:'inline-block', animation:'lpulse 1.5s infinite' }}/>}
              {isLiveMode ? 'LIVE' : 'DEMO'}
            </span>
          </div>
          <div style={{ display:'flex', gap:4, alignItems:'center' }}>
            <button onClick={() => setOffsetIdx(minOffset)} title="Go to start"
              style={{ padding:'3px 8px', borderRadius:5, border:'1px solid', borderColor: atLeftEdge?'#16a34a':'#e5e7eb', background: atLeftEdge?'#16a34a':'transparent', color: atLeftEdge?'#fff':'#6b7280', fontSize:10, cursor:'pointer', fontFamily:"'IBM Plex Mono',monospace" }}>
              Start
            </button>
            <button onClick={() => setOffsetIdx(v => Math.max(minOffset, (v ?? maxOffset) - Math.floor(VISIBLE/2)))}
              style={{ padding:'3px 8px', borderRadius:5, border:'1px solid #e5e7eb', background:'transparent', color:'#6b7280', fontSize:10, cursor:'pointer' }}>
              ◀
            </button>
            <button onClick={() => setOffsetIdx(v => Math.min(maxOffset, (v ?? maxOffset) + Math.floor(VISIBLE/2)))}
              style={{ padding:'3px 8px', borderRadius:5, border:'1px solid #e5e7eb', background:'transparent', color:'#6b7280', fontSize:10, cursor:'pointer' }}>
              ▶
            </button>
            <button onClick={() => setOffsetIdx(maxOffset)} title="Jump to today"
              style={{ padding:'3px 8px', borderRadius:5, border:'1px solid', borderColor: atRightEdge?'#16a34a':'#e5e7eb', background: atRightEdge?'#16a34a':'transparent', color: atRightEdge?'#fff':'#6b7280', fontSize:10, cursor:'pointer', fontFamily:"'IBM Plex Mono',monospace" }}>
              Now
            </button>
          </div>
        </div>
      </div>
 
      {/* Chart canvas — position:relative wraps BOTH the candle SVG and the axis SVG */}
      <div
        ref={containerRef}
        style={{ position:'relative', background:'#fff', userSelect:'none', cursor: dragRef.current ? 'grabbing' : 'crosshair' }}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleLeave}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={() => { touchRef.current = null; }}
      >
        {/* ── Axis labels — fixed to right edge, above candles ── */}
        <div style={{ position:'absolute', right:0, top:0, width:AXIS_W, height:CHART_H, pointerEvents:'none', zIndex:5, background:'rgba(255,255,255,0.92)' }}>
          <svg width={AXIS_W} height={CHART_H}>
            {gridLines.map((g, i) => (
              <text key={i} x={AXIS_W - 4} y={g.y + 3} textAnchor="end" fontSize={9} fill="#9ca3af" fontFamily="'IBM Plex Mono',monospace">
                {(g.price / 1000).toFixed(1)}k
              </text>
            ))}
          </svg>
        </div>
 
        {/* ── Candle SVG — draws only within candleAreaW, never enters axis zone ── */}
        <svg width={chartW} height={CHART_H} style={{ display:'block' }}>
          {/* Grid lines — only up to candleAreaW so they don't go behind axis */}
          {gridLines.map((g, i) => (
            <line key={i} x1={0} y1={g.y} x2={candleAreaW} y2={g.y} stroke="#f3f4f6" strokeWidth={1}/>
          ))}
 
          {/* Prediction start marker */}
          {atLeftEdge && (
            <g>
              <line x1={slot * 0.5} y1={PAD.top} x2={slot * 0.5} y2={CHART_H - PAD.bottom} stroke="#f59e0b" strokeWidth={1.5} strokeDasharray="4,3"/>
              <text x={slot * 0.5 + 4} y={PAD.top + 12} fontSize={8} fill="#f59e0b" fontFamily="'IBM Plex Mono',monospace" fontWeight={700}>Pred. Start</text>
            </g>
          )}
 
          {/* Crosshair */}
          {hover && (
            <line x1={hover.x} y1={PAD.top} x2={hover.x} y2={CHART_H - PAD.bottom} stroke="rgba(100,116,139,0.35)" strokeWidth={1} strokeDasharray="4,3"/>
          )}
 
          {/* Candles — keyed by date so React morphs elements, CSS transitions animate geometry */}
          {visData.map((d, i) => {
            const x          = (i + 0.5) * slot;
            const isLiveLast = isLiveMode && i === visData.length - 1 && d.isLive;
            const bTop       = toY(Math.max(d.open, d.close));
            const bBot       = toY(Math.min(d.open, d.close));
            const bH         = Math.max(1, bBot - bTop);
            const isUp       = d.close >= d.open;
            const color      = isUp ? '#16a34a' : '#dc2626';
            return (
              <g key={d.date}>
                {/* Wick stretches/retracts smoothly */}
                <line
                  x1={x} y1={toY(d.high)}
                  x2={x} y2={toY(d.low)}
                  stroke={color} strokeWidth={1.2}
                  style={{ transition: 'y1 0.6s ease, y2 0.6s ease' }}
                />
                {/* Body grows/shrinks in place */}
                <rect
                  x={x - cw / 2} y={bTop}
                  width={cw} height={bH}
                  rx={Math.min(1.5, cw * 0.15)}
                  fill={color}
                  style={{
                    transition: 'y 0.6s ease, height 0.6s ease',
                    filter: isLiveLast ? `drop-shadow(0 0 3px ${color})` : 'none',
                  }}
                />
              </g>
            );
          })}
 
          {/* Tooltip */}
          {hover && hover.candle && (() => {
            const c  = hover.candle;
            const tx = hover.x > candleAreaW * 0.65 ? hover.x - 86 : hover.x + 8;
            const isUp = c.close >= c.open;
            return (
              <g>
                <rect x={tx} y={PAD.top + 4} width={84} height={62} rx={5} fill="#1e293b" opacity={0.93}/>
                <text x={tx+42} y={PAD.top+16} textAnchor="middle" fontSize={8} fill="#94a3b8" fontFamily="'IBM Plex Mono',monospace">{c.date}</text>
                {[['O', c.open], ['H', c.high], ['L', c.low], ['C', c.close]].map(([l, v], ii) => (
                  <g key={l}>
                    <text x={tx+7}  y={PAD.top+27+ii*10} fontSize={8} fill="#64748b" fontFamily="'IBM Plex Mono',monospace">{l}</text>
                    <text x={tx+78} y={PAD.top+27+ii*10} textAnchor="end" fontSize={8}
                      fill={l==='C' ? (isUp?'#4ade80':'#f87171') : '#e2e8f0'}
                      fontFamily="'IBM Plex Mono',monospace" fontWeight={l==='C'?700:400}>
                      {(v/1000).toFixed(1)}k
                    </text>
                  </g>
                ))}
              </g>
            );
          })()}
 
          {/* X-axis date labels */}
          {visData.filter((_, i) => i % Math.max(1, Math.floor(visData.length / 7)) === 0).map((d, i) => {
            const origIdx = visData.indexOf(d);
            const x = (origIdx + 0.5) * slot;
            // Skip labels that would render into the axis zone
            if (x > candleAreaW - 10) return null;
            return (
              <text key={i} x={x} y={CHART_H - 4} textAnchor="middle" fontSize={9} fill="#9ca3af" fontFamily="'IBM Plex Mono',monospace">
                {fmtS(d.date)}
              </text>
            );
          })}
        </svg>
 
        {/* Volume bars */}
        <div style={{ borderTop:'1px solid #f3f4f6', padding:'4px 0 2px' }}>
          <div style={{ paddingLeft:6, fontSize:8, color:'#9ca3af', fontFamily:"'IBM Plex Mono',monospace", marginBottom:1, textTransform:'uppercase', letterSpacing:1 }}>VOL</div>
          <svg width={chartW} height={VOL_H} style={{ display:'block' }}>
            {visData.map((d, i) => {
              const bh   = Math.max(2, ((d.volume || 0) / maxVol) * (VOL_H - 8));
              const isUp = d.close >= d.open;
              const bw   = Math.max(1.5, cw * 0.85);
              // Volume bars also respect the candleAreaW boundary
              const x = (i + 0.5) * slot;
              if (x > candleAreaW) return null;
              return (
                <rect key={i} x={x - bw/2} y={VOL_H - bh} width={bw} height={bh} rx={1}
                  fill={isUp ? '#16a34a' : '#dc2626'} fillOpacity={0.32}/>
              );
            })}
          </svg>
        </div>
 
        <div style={{ display:'flex', justifyContent:'space-between', padding:'4px 8px 6px', borderTop:'1px solid #f9fafb' }}>
          <span style={{ fontSize:8, color:'#9ca3af', fontFamily:"'IBM Plex Mono',monospace" }}>
            {allData.length} sessions · {allData[0]?.date ? fmtS(allData[0].date) : ''} – {latest?.date ? fmtS(latest.date) : ''}
          </span>
          <span style={{ fontSize:8, color:'#d4a017', fontFamily:"'IBM Plex Mono',monospace", fontWeight:700 }}>NGX AGRI</span>
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════
   DONUT CHART  — compact, same visual weight as bar charts
═══════════════════════════════════════════════════ */
const CAT_COLORS = {
  Grains:'#16a34a', Legumes:'#2563eb', Tubers:'#d97706',
  Protein:'#dc2626', Produce:'#0891b2', Staples:'#7c3aed', Fuel:'#64748b',
};
 
function DonutChart() {
  const cats = Object.keys(CAT_COLORS);
  const catMapes = cats.map(cat => ({
    name: cat, color: CAT_COLORS[cat],
    val: parseFloat((
      ALL_COMMODITIES.filter(c => c.cat === cat).reduce((s, c) => s + c.mape, 0) /
      Math.max(1, ALL_COMMODITIES.filter(c => c.cat === cat).length)
    ).toFixed(1)),
  }));
  const total  = catMapes.reduce((s, c) => s + c.val, 0);
  const avgAll = (ALL_COMMODITIES.reduce((s, c) => s + c.mape, 0) / ALL_COMMODITIES.length).toFixed(1);
 
  // Smaller donut dimensions
  const cx = 72, cy = 72, R = 58, ri = 36;
  const toRad = deg => deg * Math.PI / 180;
  let cur = -90;
  const segs = catMapes.map(d => {
    const sw = (d.val / total) * 360;
    const s = cur, e = cur + sw;
    cur = e;
    const [x1, y1] = [cx + R * Math.cos(toRad(s)), cy + R * Math.sin(toRad(s))];
    const [x2, y2] = [cx + R * Math.cos(toRad(e)), cy + R * Math.sin(toRad(e))];
    const [xi1, yi1] = [cx + ri * Math.cos(toRad(s)), cy + ri * Math.sin(toRad(s))];
    const [xi2, yi2] = [cx + ri * Math.cos(toRad(e)), cy + ri * Math.sin(toRad(e))];
    const lg = sw > 180 ? 1 : 0;
    return {
      ...d,
      path: `M ${x1},${y1} A ${R},${R} 0 ${lg},1 ${x2},${y2} L ${xi2},${yi2} A ${ri},${ri} 0 ${lg},0 ${xi1},${yi1} Z`,
    };
  });
 
  return (
    <div style={{
      background: '#fff', borderRadius: 14, border: '1px solid var(--slate-200)',
      padding: '12px 10px 12px', boxShadow: '0 2px 10px rgba(0,0,0,0.04)',
      display: 'flex', flexDirection: 'column', gap: 0,
    }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--slate-800)', fontFamily: 'var(--font-head)', marginBottom: 10 }}>
        MAPE by Category
      </div>
 
      {/* Donut — centred, compact */}
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 14 }}>
        <svg width={144} height={144} viewBox="0 0 144 144" style={{ display: 'block' }}>
          {segs.map((s, i) => (
            <path key={i} d={s.path} fill={s.color} opacity={0.9}
              style={{ transition: 'opacity .2s' }}
              onMouseEnter={e => e.currentTarget.setAttribute('opacity', '1')}
              onMouseLeave={e => e.currentTarget.setAttribute('opacity', '0.9')} />
          ))}
          <text x={cx} y={cy - 6} textAnchor="middle" fontSize={15} fontWeight={800} fill="#1e293b" fontFamily="'IBM Plex Mono',monospace">{avgAll}%</text>
          <text x={cx} y={cy + 9} textAnchor="middle" fontSize={8} fill="#94a3b8" fontFamily="'IBM Plex Mono',monospace">Avg MAPE</text>
        </svg>
      </div>
 
      {/* Legend — 2-col grid, fully inside card */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '7px 6px', padding: '0 2px' }}>
        {catMapes.map(d => (
          <div key={d.name} style={{ display: 'flex', alignItems: 'center', gap: 4, minWidth: 0 }}>
            <span style={{ width: 7, height: 7, borderRadius: 2, background: d.color, flexShrink: 0 }} />
            <span style={{
              flex: 1, fontSize: 9, color: 'var(--slate-600)',
              fontFamily: 'var(--font-head)', overflow: 'hidden',
              textOverflow: 'ellipsis', whiteSpace: 'nowrap',
            }}>{d.name}</span>
            <span style={{
              fontFamily: 'var(--mono)', fontWeight: 700, fontSize: 9,
              color: 'var(--slate-700)', flexShrink: 0, marginLeft: 2,
            }}>{d.val}%</span>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════
   PRICE BAR CHART  (horizontal bars)
═══════════════════════════════════════════════════ */
function PriceBarChart({ prices }) {
  const data = useMemo(() =>
    [...ALL_COMMODITIES].sort((a, b) => b.base - a.base).slice(0, 10).map(c => {
      const pd = prices[c.name] || { price:c.base, falling:c.trend===-1 };
      return {
        name: c.name.replace(/ \(.*\)/, '').substring(0, 12),
        price: pd.price,
        falling: pd.falling,
      };
    }), [prices]);
  const maxP = Math.max(...data.map(d => d.price));
  return (
    <div style={{ background:'#fff', borderRadius:14, border:'1px solid var(--slate-200)', padding:'12px', boxShadow:'0 2px 10px rgba(0,0,0,0.04)' }}>
      <div style={{ fontSize:11, fontWeight:700, color:'var(--slate-800)', fontFamily:'var(--font-head)', marginBottom:10 }}>Price Comparison — Top 10</div>
      <div style={{ display:'flex', flexDirection:'column', gap:7 }}>
        {data.map(d => (
          <div key={d.name} style={{ display:'flex', alignItems:'center', gap:8 }}>
            <span style={{ width:72, fontSize:9, color:'var(--slate-600)', flexShrink:0, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', fontFamily:'var(--font-head)' }}>{d.name}</span>
            <div style={{ flex:1, height:8, background:'var(--slate-100)', borderRadius:4, overflow:'hidden' }}>
              <div style={{ height:'100%', borderRadius:4, width:`${(d.price/maxP)*100}%`, background:d.falling?'#2563eb':'#dc2626', transition:'width 1.2s ease' }}/>
            </div>
            <span style={{ fontFamily:'var(--mono)', fontWeight:700, fontSize:9, color:'var(--slate-700)', width:40, textAlign:'right', flexShrink:0 }}>₦{(d.price/1000).toFixed(0)}k</span>
          </div>
        ))}
      </div>
      <div style={{ display:'flex', gap:12, marginTop:8, fontSize:9 }}>
        <span style={{ display:'flex', alignItems:'center', gap:4, color:'var(--slate-500)' }}>
          <span style={{ width:8, height:8, background:'#2563eb', borderRadius:2, display:'inline-block' }}/>Falling
        </span>
        <span style={{ display:'flex', alignItems:'center', gap:4, color:'var(--slate-500)' }}>
          <span style={{ width:8, height:8, background:'#dc2626', borderRadius:2, display:'inline-block' }}/>Rising
        </span>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════
   ALL COMMODITIES CHART  (vertical bars)
═══════════════════════════════════════════════════ */
function SvgBarChart({ data, height = 180 }) {
  const PAD = { top:6, bottom:28, left:0, right:0 };
  const cH  = height - PAD.top - PAD.bottom;
  const maxP = Math.max(...data.map(d => d.price), 1);
  const toY  = p => PAD.top + cH - (p / maxP) * cH;
  const w    = Math.max(data.length * 22, 160);
  const slot = w / data.length;
  const bw   = Math.max(4, slot * 0.62);
  return (
    <div style={{ overflowX:'auto', scrollbarWidth:'thin' }}>
      <svg width={w} height={height} style={{ display:'block' }}>
        {[0.25, 0.5, 0.75, 1].map((f, i) => (
          <line key={i} x1={0} y1={toY(maxP*f)} x2={w} y2={toY(maxP*f)} stroke="#f1f5f9" strokeWidth={0.8}/>
        ))}
        {data.map((d, i) => {
          const x  = i * slot + (slot - bw) / 2;
          const y  = toY(d.price);
          const bh = Math.max(2, (height - PAD.bottom) - y);
          return (
            <g key={i}>
              <rect x={x} y={y} width={bw} height={bh} rx={3} fill={d.falling?'#2563eb':'#dc2626'} fillOpacity={0.82}/>
              <text x={x+bw/2} y={height-PAD.bottom+11} textAnchor="middle" fontSize={7} fill="#94a3b8"
                fontFamily="'IBM Plex Mono',monospace"
                transform={`rotate(-35,${x+bw/2},${height-PAD.bottom+11})`}>{d.name}</text>
            </g>
          );
        })}
      </svg>
    </div>
  );
}

function AllCommoditiesChart({ prices }) {
  const [cat, setCat] = useState('All');
  const filtered  = ALL_COMMODITIES.filter(c => cat === 'All' || c.cat === cat);
  const chartData = filtered.map(c => {
    const pd = prices[c.name] || { price:c.base, falling:c.trend===-1 };
    return { name:c.name.replace(/ \(.*\)/, '').substring(0, 7), price:pd.price, falling:pd.falling };
  });
  return (
    <div style={{ background:'#fff', borderRadius:14, border:'1px solid var(--slate-200)', overflow:'hidden', boxShadow:'0 2px 10px rgba(0,0,0,0.04)', display:'flex', minHeight:240 }}>
      <div style={{ width:72, background:'var(--slate-50)', borderRight:'1px solid var(--slate-100)', display:'flex', flexDirection:'column', padding:'8px 0', flexShrink:0 }}>
        <div style={{ fontSize:7, textTransform:'uppercase', letterSpacing:'0.1em', color:'var(--slate-400)', fontWeight:700, padding:'0 6px', marginBottom:4, fontFamily:'var(--mono)' }}>Cat.</div>
        {CATS.map(c => (
          <button key={c} onClick={() => setCat(c)}
            style={{ padding:'5px 6px', background:cat===c?'var(--green-900)':'transparent', border:'none', cursor:'pointer', textAlign:'left', transition:'all 0.15s', fontSize:9, fontWeight:700, color:cat===c?'#fff':'var(--slate-500)', fontFamily:'var(--font-head)', borderLeft:cat===c?'2.5px solid var(--gold)':'2.5px solid transparent', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
            {c}
          </button>
        ))}
      </div>
      <div style={{ flex:1, padding:'8px 6px 4px', display:'flex', flexDirection:'column', minWidth:0 }}>
        <div style={{ fontSize:10, fontWeight:700, color:'var(--slate-800)', fontFamily:'var(--font-head)', marginBottom:4 }}>
          {cat} <span style={{ fontSize:9, color:'var(--slate-400)', fontWeight:500 }}>({filtered.length})</span>
        </div>
        <div style={{ flex:1, overflowX:'auto' }}>
          <SvgBarChart data={chartData} height={180}/>
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════
   STAT MINI
═══════════════════════════════════════════════════ */
function StatMini({ icon, value, label }) {
  const isNum = typeof value === 'number';
  const [v, ref] = useAnimatedCount(isNum ? value : 0, 1400);
  return (
    <div ref={ref} style={{ background:'rgba(255,255,255,0.07)', borderRadius:10, padding:'8px 6px', border:'1px solid rgba(255,255,255,0.08)', display:'flex', flexDirection:'column', alignItems:'center', gap:2 }}>
      <div style={{ color:'var(--gold)' }}>{icon}</div>
      <div style={{ fontFamily:'var(--font-head)', fontSize:13, fontWeight:800, color:'#fff', lineHeight:1 }}>{isNum ? v : value}</div>
      <div style={{ fontSize:7, color:'rgba(255,255,255,0.4)', textTransform:'uppercase', letterSpacing:'0.08em', fontFamily:'var(--mono)', textAlign:'center', lineHeight:1.3 }}>{label}</div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════
   NAV BTN  — FIXED ICONS
   donut    = circle/donut icon
   bar      = sideways (horizontal) bar chart icon
   allchart = vertical bar chart icon  (NOT waveform)
═══════════════════════════════════════════════════ */
function NavBtn({ icon, label, active, onClick }) {
  const [tip, setTip] = useState(false);
  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={onClick}
        onMouseEnter={() => setTip(true)}
        onMouseLeave={() => setTip(false)}
        style={{
          /* ↓ reduced from 44×44 to 40×40 */
          width: 40, height: 40, borderRadius: 10, border: 'none', cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          transition: 'all 0.18s',
          background: active ? 'var(--green-900)' : 'var(--slate-100)',
          color: active ? 'var(--gold)' : 'var(--slate-500)',
          boxShadow: active ? '0 3px 12px rgba(10,46,20,0.35)' : 'none',
        }}>
        {icon}
      </button>
      {tip && (
        <div style={{
          position: 'absolute', left: 'calc(100% + 10px)', top: '50%',
          transform: 'translateY(-50%)', background: 'var(--slate-800)', color: '#fff',
          fontSize: 10, fontWeight: 700, padding: '4px 10px', borderRadius: 6,
          whiteSpace: 'nowrap', pointerEvents: 'none', zIndex: 300,
          fontFamily: 'var(--font-head)', boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
        }}>
          {label}
          <div style={{
            position: 'absolute', right: '100%', top: '50%', transform: 'translateY(-50%)',
            width: 0, height: 0,
            borderTop: '5px solid transparent', borderBottom: '5px solid transparent',
            borderRight: '5px solid var(--slate-800)',
          }} />
        </div>
      )}
    </div>
  );
}

/* ═══════════════════════════════════════════════════
   RIGHT ICON BTN
═══════════════════════════════════════════════════ */
function RightIconBtn({ icon, label, onClick, active }) {
  const [tip, setTip] = useState(false);
  return (
    <div style={{ position:'relative' }}>
      <button onClick={onClick} onMouseEnter={() => setTip(true)} onMouseLeave={() => setTip(false)}
        style={{ width:32, height:32, borderRadius:8, border:'none', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', transition:'all 0.15s', background:active?'var(--green-900)':'var(--slate-100)', color:active?'var(--gold)':'var(--slate-600)', boxShadow:active?'0 2px 8px rgba(10,46,20,0.3)':'none' }}>
        {icon}
      </button>
      {tip && (
        <div style={{ position:'absolute', top:'100%', right:0, marginTop:6, background:'var(--slate-800)', color:'#fff', fontSize:9, fontWeight:700, padding:'3px 8px', borderRadius:5, whiteSpace:'nowrap', pointerEvents:'none', zIndex:100, fontFamily:'var(--font-head)' }}>{label}</div>
      )}
    </div>
  );
}

/* ═══════════════════════════════════════════════════
   COMMODITY ROW
═══════════════════════════════════════════════════ */
function CommodityRow({ c, pd, onPredict, rowNum }) {
  const { price, pct, falling } = pd;
  const [tipVis, setTipVis] = useState(false);
  const col   = falling ? '#2563eb' : '#dc2626';
  const conf  = c.mape < 10 ? 'High' : c.mape < 20 ? 'Mid' : 'Low';
  const confC = conf==='High'?'#15803d':conf==='Mid'?'#b45309':'#b91c1c';
  const confB = conf==='High'?'#dcfce7':conf==='Mid'?'#fef3c7':'#fee2e2';
  return (
    <div style={{ display:'flex', alignItems:'center', padding:'9px 12px', borderBottom:'1px solid var(--slate-100)', gap:10, transition:'background 0.12s', cursor:'default' }}
      onMouseEnter={e => e.currentTarget.style.background='var(--slate-50)'}
      onMouseLeave={e => e.currentTarget.style.background='transparent'}>
      <span style={{ width:18, fontSize:9, fontWeight:700, color:'var(--slate-400)', fontFamily:'var(--mono)', textAlign:'right', flexShrink:0 }}>{rowNum}</span>
      <div style={{ width:40, height:40, borderRadius:9, overflow:'hidden', flexShrink:0, background:'var(--slate-100)' }}>
        {PHOTOS[c.name] && <img src={PHOTOS[c.name]} alt={c.name} style={{ width:'100%', height:'100%', objectFit:'cover' }} loading="lazy"/>}
      </div>
      <div style={{ flex:1, minWidth:0 }}>
        <div style={{ fontSize:12, fontWeight:700, color:'var(--slate-800)', fontFamily:'var(--font-head)', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{c.name}</div>
        <div style={{ fontSize:8, color:'var(--slate-400)', textTransform:'uppercase', letterSpacing:'0.04em', marginTop:1 }}>{c.unit} · MAPE {c.mape}%</div>
      </div>
      <span style={{ fontSize:8, fontWeight:700, padding:'2px 7px', borderRadius:20, background:confB, color:confC, flexShrink:0, fontFamily:'var(--font-head)' }}>{conf}</span>
      <div style={{ textAlign:'right', flexShrink:0, minWidth:80 }}>
        <div style={{ fontFamily:'var(--mono)', fontSize:13, fontWeight:700, color:'var(--slate-900)', letterSpacing:'-0.3px' }}>₦{price.toLocaleString()}</div>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'flex-end', gap:3, marginTop:2 }}>
          <span style={{ fontSize:10, fontWeight:800, color:col }}>{falling?'▼':'▲'}</span>
          <span style={{ fontSize:9, fontWeight:700, color:col, fontFamily:'var(--mono)' }}>{Math.abs(pct)}%</span>
        </div>
      </div>
      <div style={{ position:'relative', flexShrink:0 }}>
        <button onClick={() => onPredict(c.name)} onMouseEnter={() => setTipVis(true)} onMouseLeave={() => setTipVis(false)}
          style={{ width:30, height:30, borderRadius:8, border:'none', cursor:'pointer', background:'var(--green-900)', color:'var(--gold)', display:'flex', alignItems:'center', justifyContent:'center', boxShadow:'0 2px 8px rgba(10,46,20,0.25)', transition:'background 0.15s' }}
          onMouseOver={e => e.currentTarget.style.background='#15803d'}
          onMouseOut={e  => e.currentTarget.style.background='var(--green-900)'}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
        </button>
        {tipVis && <div style={{ position:'absolute', bottom:'100%', right:0, marginBottom:5, background:'var(--slate-800)', color:'#fff', fontSize:9, fontWeight:700, padding:'3px 8px', borderRadius:5, whiteSpace:'nowrap', pointerEvents:'none', zIndex:50, fontFamily:'var(--font-head)' }}>Predict</div>}
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════
   TICKER
═══════════════════════════════════════════════════ */
function Ticker({ prices }) {
  const items = ALL_COMMODITIES.map(c => ({ ...c, ...(prices[c.name]||{price:c.base,pct:'0.00',falling:c.trend===-1}) }));
  return (
    <div style={{ background:'linear-gradient(90deg,var(--green-900),#0d3b1a)', borderRadius:12, padding:'0.5rem 1rem', display:'flex', alignItems:'center', gap:'0.75rem', overflow:'hidden', boxShadow:'0 3px 16px rgba(10,46,20,0.18)', border:'1px solid rgba(212,160,23,0.12)', flexShrink:0 }}>
      <span style={{ fontSize:10, textTransform:'uppercase', letterSpacing:'0.08em', color:'var(--gold-light)', fontWeight:700, whiteSpace:'nowrap', display:'flex', alignItems:'center', gap:6 }}>
        <span style={{ width:7, height:7, borderRadius:'50%', background:'#22c55e', animation:'lpulse 2s infinite', display:'inline-block' }}/>Live
      </span>
      <div style={{ width:1, height:14, background:'rgba(255,255,255,0.2)', flexShrink:0 }}/>
      <div style={{ overflow:'hidden', flex:1 }}>
        <div style={{ display:'flex', gap:'1.5rem', animation:'lticker 52s linear infinite', whiteSpace:'nowrap' }}>
          {[...items, ...items].map((item, i) => (
            <span key={i} style={{ display:'inline-flex', alignItems:'center', gap:5, fontSize:12, color:'rgba(255,255,255,0.85)' }}>
              <strong style={{ color:'#fff', fontWeight:600 }}>{item.name}</strong>
              <span style={{ color:item.falling?'#7dd3fc':'#fca5a5', fontFamily:'var(--mono)', fontSize:11 }}>{item.falling?'▼':'▲'} ₦{Number(item.price).toLocaleString()}</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════
   LIVE PRICE MINI
═══════════════════════════════════════════════════ */
function LivePriceMini({ commodity, prices, ohlc }) {
  const cd   = ALL_COMMODITIES.find(c => c.name === commodity) || ALL_COMMODITIES[0];
  const pd   = prices[cd.name] || { price: cd.base, pct: '0.00', falling: false };
  const livePrice = pd.price;
  const rising = !pd.falling;
  const latest = ohlc[ohlc.length - 1] || { open:cd.base, high:cd.base, low:cd.base, close:cd.base };
  const hist   = ohlc.slice(-24).map(d => d.close);
  const mn     = Math.min(...hist), mx = Math.max(...hist);
  const toSY   = v => 44 - ((v - mn) / (mx - mn + 1)) * 40;
  const pts    = hist.map((v, i) => `${(i / (hist.length-1)) * 260},${toSY(v)}`).join(' ');
  return (
    <div style={{ display:'flex', flexDirection:'column', gap:8, padding:'10px 12px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
        <div>
          <div style={{ fontSize:10, color:'var(--slate-500)', fontFamily:'var(--mono)', textTransform:'uppercase', letterSpacing:1 }}>{cd.name}</div>
          <div style={{ fontSize:22, fontWeight:700, fontFamily:'var(--mono)', color:'var(--slate-900)', letterSpacing:-0.5 }}>₦{livePrice.toLocaleString()}</div>
          <div style={{ fontSize:10, fontWeight:700, color:rising?'#dc2626':'#2563eb', fontFamily:'var(--mono)', display:'flex', alignItems:'center', gap:3, marginTop:2 }}>
            {rising?'▲':'▼'} {Math.abs(pd.pct)}% vs open
          </div>
        </div>
      </div>
      <div style={{ background:'#fff', borderRadius:10, border:'1px solid var(--slate-100)', padding:'8px 6px' }}>
        <div style={{ fontSize:9, color:'var(--slate-400)', textTransform:'uppercase', letterSpacing:'0.07em', marginBottom:4, fontFamily:'var(--mono)' }}>Price Movement</div>
        <svg width="100%" viewBox="0 0 260 44" preserveAspectRatio="none" style={{ display:'block', height:44 }}>
          <polyline points={pts} fill="none" stroke={rising?'#dc2626':'#2563eb'} strokeWidth="1.8" strokeLinejoin="round"/>
          <circle cx={260} cy={toSY(livePrice)} r="3" fill={rising?'#dc2626':'#2563eb'} style={{ animation:'lpulse 1.2s infinite' }}/>
        </svg>
        <div style={{ display:'flex', justifyContent:'space-between', fontSize:8, color:'var(--slate-400)', fontFamily:'var(--mono)', marginTop:2 }}>
          <span>Earlier</span><span>Now</span>
        </div>
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:4 }}>
        {[['O',latest.open],['H',latest.high],['L',latest.low],['C',latest.close]].map(([lbl,val]) => (
          <div key={lbl} style={{ background:'var(--slate-50)', borderRadius:7, padding:'5px 3px', textAlign:'center', border:'1px solid var(--slate-100)' }}>
            <div style={{ fontSize:8, color:'var(--slate-400)', fontFamily:'var(--mono)', textTransform:'uppercase' }}>{lbl}</div>
            <div style={{ fontSize:10, fontWeight:700, color:'var(--slate-800)', fontFamily:'var(--mono)' }}>{((val||0)/1000).toFixed(1)}k</div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════
   RIGHT DETAIL VIEW
═══════════════════════════════════════════════════ */
function RightDetailView({ state, ohlc, onBack, onPredict, prices }) {
  const cd = ALL_COMMODITIES.find(c => c.name === state) || ALL_COMMODITIES[0];
  return (
    <div style={{ padding:'12px 14px' }}>
      <button onClick={onBack} style={{ display:'inline-flex', alignItems:'center', gap:5, fontSize:11, color:'var(--slate-500)', cursor:'pointer', marginBottom:10, background:'none', border:'none', padding:0, fontFamily:'var(--font-head)' }}>
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>
        Back to Map
      </button>
      <div style={{ fontSize:13, fontWeight:700, color:'var(--slate-800)', fontFamily:'var(--font-head)', marginBottom:8 }}>{state} — Price Detail</div>
      <LivePriceMini commodity={state} prices={prices} ohlc={ohlc}/>
      <button onClick={onPredict} style={{ width:'100%', marginTop:10, background:'var(--green-900)', color:'var(--gold)', border:'none', borderRadius:10, padding:'9px 12px', fontSize:12, fontWeight:700, cursor:'pointer', fontFamily:'var(--font-head)', display:'flex', alignItems:'center', justifyContent:'center', gap:6 }}>
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
        Predict prices for {state}
      </button>
    </div>
  );
}

/* ═══════════════════════════════════════════════════
   NIGERIA MAP WRAPPER  — map fills container, readable labels
═══════════════════════════════════════════════════ */
function NigeriaMapWithFlag({ onPredictClick, onStateClick }) {
  return (
    <div style={{ position:'relative', width:'100%' }}>
      <div style={{
        position:'absolute', top:0, left:0, right:0, zIndex:10,
        display:'flex', alignItems:'center', pointerEvents:'none',
        padding:'14px 16px 0',backgroundImage:'data:image/jpeg;base64,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'
      }}>
        {/* Nigeria flag built with CSS — no external image needed */}
        <div style={{
          width:28, height:19, borderRadius:3,
          border:'1px solid rgba(0,0,0,0.1)',
          display:'flex', overflow:'hidden', flexShrink:0, marginRight:8
        }}>
        </div>
      </div>
      <div style={{ width:'100%', minHeight:400 }}>
        <NigeriaMap
          onPredictClick={onPredictClick}
          onStateClick={onStateClick}
        />
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════
   WATCHLIST PANEL  — professional pin system
   - Star icon toggles pin on currently selected commodity
   - Only ONE commodity can be pinned at a time
   - Pinned commodity persists in localStorage
   - Dropdown to select which commodity chart to view
   - Notification badge on pin
═══════════════════════════════════════════════════ */
function WatchlistPanel({ isLive, effectivePrices }) {
  /* Restore pinned commodity from localStorage */
  const [pinnedCommodity, setPinnedCommodity] = useState(() => {
    try { return localStorage.getItem('naija_watchlist_pin') || null; } catch { return null; }
  });

  /* Active commodity in the dropdown — default to pinned or Maize */
  const [watchCommodity, setWatchCommodity] = useState(() => {
    try { return localStorage.getItem('naija_watchlist_pin') || 'Maize'; } catch { return 'Maize'; }
  });

  /* Show a brief "Pinned" notification */
  const [showPinNotif, setShowPinNotif] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropRef = useRef(null);

  const isPinned = pinnedCommodity === watchCommodity;

  function togglePin() {
    if (isPinned) {
      /* Unpin */
      setPinnedCommodity(null);
      try { localStorage.removeItem('naija_watchlist_pin'); } catch {}
    } else {
      /* Pin current selection — replace any previous pin */
      setPinnedCommodity(watchCommodity);
      try { localStorage.setItem('naija_watchlist_pin', watchCommodity); } catch {}
      setShowPinNotif(true);
      setTimeout(() => setShowPinNotif(false), 2800);
    }
  }

  /* Close dropdown on outside click */
  useEffect(() => {
    function handler(e) {
      if (dropRef.current && !dropRef.current.contains(e.target)) setShowDropdown(false);
    }
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const selectedCom = ALL_COMMODITIES.find(c => c.name === watchCommodity) || ALL_COMMODITIES.find(c => c.name === 'Maize');
  const basePrice   = selectedCom ? selectedCom.base : 42800;
  const unit        = selectedCom ? selectedCom.unit : '/50kg';

  return (
    <div style={{ background:'#fff', borderRadius:14, border:'1px solid var(--slate-200)', overflow:'visible', boxShadow:'0 2px 10px rgba(0,0,0,0.04)' }}>

      {/* Watchlist header — professional */}
      <div style={{ padding:'10px 12px 8px', borderBottom:'1px solid var(--slate-100)', display:'flex', alignItems:'center', justifyContent:'space-between', gap:8, position:'relative' }}>

        {/* Left: star pin button + title */}
        <div style={{ display:'flex', alignItems:'center', gap:7 }}>
          <button
            onClick={togglePin}
            title={isPinned ? `Unpin ${watchCommodity}` : `Pin ${watchCommodity} to watchlist`}
            style={{
              background:'none', border:'none', cursor:'pointer', padding:2,
              color: isPinned ? '#d4a017' : 'var(--slate-400)',
              transition:'color .2s, transform .15s',
              display:'flex', alignItems:'center',
            }}
            onMouseEnter={e => { e.currentTarget.style.transform='scale(1.18)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform='scale(1)'; }}>
            {/* Filled star when pinned, outline when not */}
            {isPinned ? (
              <svg width="15" height="15" viewBox="0 0 24 24" fill="#d4a017" stroke="#d4a017" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
              </svg>
            ) : (
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
              </svg>
            )}
          </button>

          <div>
            <div style={{ display:'flex', alignItems:'center', gap:5 }}>
              <span style={{ fontSize:11, fontWeight:700, color:'var(--slate-800)', fontFamily:'var(--font-head)' }}>
                Watchlist
              </span>
              {pinnedCommodity && (
                <span style={{ fontSize:9, fontWeight:700, color:'#d4a017', background:'#fef3c7', border:'1px solid rgba(212,160,23,0.3)', borderRadius:20, padding:'1px 6px', fontFamily:'var(--font-head)', display:'flex', alignItems:'center', gap:3 }}>
                  <svg width="8" height="8" viewBox="0 0 24 24" fill="#d4a017" stroke="#d4a017" strokeWidth="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                  {pinnedCommodity.split(' ')[0]}
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Right: commodity selector dropdown */}
        <div ref={dropRef} style={{ position:'relative' }}>
          <button
            onClick={() => setShowDropdown(v => !v)}
            style={{
              display:'flex', alignItems:'center', gap:5, padding:'4px 8px 4px 10px',
              borderRadius:7, border:'1.5px solid var(--slate-200)', background:'var(--slate-50)',
              cursor:'pointer', fontSize:10, fontWeight:700, color:'var(--slate-700)',
              fontFamily:'var(--font-head)', transition:'border-color .15s',
              maxWidth:120, overflow:'hidden', whiteSpace:'nowrap', textOverflow:'ellipsis',
            }}
            onMouseEnter={e => e.currentTarget.style.borderColor='var(--green-700)'}
            onMouseLeave={e => e.currentTarget.style.borderColor='var(--slate-200)'}>
            <span style={{ overflow:'hidden', textOverflow:'ellipsis', flex:1 }}>
              {watchCommodity.split(' ')[0].replace(/\(.*\)/, '')}
            </span>
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <polyline points="6 9 12 15 18 9"/>
            </svg>
          </button>

          {showDropdown && (
            <div style={{
              position:'absolute', top:'calc(100% + 5px)', right:0, zIndex:400,
              background:'#fff', border:'1.5px solid var(--slate-200)', borderRadius:10,
              boxShadow:'0 8px 28px rgba(0,0,0,0.12)', minWidth:180, maxHeight:220,
              overflowY:'auto', scrollbarWidth:'thin',
            }}>
              {ALL_COMMODITIES.map(c => (
                <button
                  key={c.name}
                  onClick={() => { setWatchCommodity(c.name); setShowDropdown(false); }}
                  style={{
                    width:'100%', textAlign:'left', padding:'7px 12px', border:'none',
                    background: watchCommodity===c.name ? 'var(--green-900)' : 'transparent',
                    color: watchCommodity===c.name ? '#fff' : 'var(--slate-700)',
                    cursor:'pointer', fontSize:11, fontFamily:'var(--font-head)',
                    display:'flex', alignItems:'center', justifyContent:'space-between', gap:6,
                    borderBottom:'1px solid var(--slate-100)',
                  }}
                  onMouseEnter={e => { if (watchCommodity !== c.name) e.currentTarget.style.background='var(--slate-50)'; }}
                  onMouseLeave={e => { if (watchCommodity !== c.name) e.currentTarget.style.background='transparent'; }}>
                  <span style={{ overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{c.name}</span>
                  {pinnedCommodity === c.name && (
                    <svg width="9" height="9" viewBox="0 0 24 24" fill="#d4a017" stroke="#d4a017" strokeWidth="1">
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                    </svg>
                  )}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Pin notification toast */}
        {showPinNotif && (
          <div style={{
            position:'absolute', top:'calc(100% + 6px)', left:'50%', transform:'translateX(-50%)',
            background:'#0a2e14', color:'#d4a017', fontSize:10, fontWeight:700,
            padding:'5px 14px', borderRadius:20, whiteSpace:'nowrap', zIndex:500,
            border:'1px solid rgba(212,160,23,0.35)', fontFamily:'var(--font-head)',
            boxShadow:'0 4px 14px rgba(0,0,0,0.18)',
            display:'flex', alignItems:'center', gap:6,
            animation:'fadeInUp .25s ease',
          }}>
            <svg width="11" height="11" viewBox="0 0 24 24" fill="#d4a017" stroke="#d4a017" strokeWidth="1">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
            </svg>
            {watchCommodity.split(' ')[0]} pinned to watchlist
          </div>
        )}
      </div>

      {/* Candlestick for selected commodity */}
      <div style={{ padding:'4px 4px 2px' }}>
        <InteractiveCandlestick
          commodity={watchCommodity}
          unit={unit}
          basePrice={basePrice}
          isLiveMode={isLive}
        />
      </div>

      {/* Bottom info bar */}
      <div style={{ padding:'6px 12px 8px', borderTop:'1px solid var(--slate-100)', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <span style={{ fontSize:9, color:'var(--slate-400)', fontFamily:'var(--mono)' }}>
          {isPinned ? 'Pinned — restores on next visit' : 'Pin to keep this chart on return'}
        </span>
        {isPinned && (
          <button onClick={togglePin}
            style={{ fontSize:9, color:'var(--slate-400)', background:'none', border:'none', cursor:'pointer', fontFamily:'var(--font-head)', textDecoration:'underline', padding:0 }}>
            Unpin
          </button>
        )}
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════
   MAIN
═══════════════════════════════════════════════════ */
export default function LandingPage({
  onPredictClick, onNewsClick, onPricesClick,
  priceMode = 'student', onModeToggle, onNavigate,
  user = null, onUserChange,
}) {
  const prices        = useLivePrices();
  const isMobile      = useIsMobile();
  const triggerRipple = useRipple();

  const [activeChart, setActiveChart] = useState('donut');

  const [rightView, setRightView]         = useState('map');
  const [selectedState, setSelectedState] = useState(null);
  const [rightOhlc, setRightOhlc]         = useState(() => genOHLC(42800));

  const [activeTab, setActiveTab] = useState('All');
  const [search,    setSearch]    = useState('');
  const [lastUpdate,setLastUpdate]= useState(new Date());

  const isLive = priceMode === 'live';
  const [liveOverrides, setLiveOverrides] = useState({});
  useEffect(() => {
    if (!isLive) { setLiveOverrides({}); return; }
    fetchLivePrices(ALL_COMMODITIES.map(c => c.name), 'Lagos')
      .then(d => { if (d) setLiveOverrides(d); }).catch(() => {});
  }, [isLive]);

  const effectivePrices = useMemo(() => {
    if (!isLive || !Object.keys(liveOverrides).length) return prices;
    const m = { ...prices };
    for (const [name, info] of Object.entries(liveOverrides)) {
      if (m[name]) m[name] = { ...m[name], ...info };
    }
    return m;
  }, [prices, liveOverrides, isLive]);

  useEffect(() => {
    const t = setInterval(() => setLastUpdate(new Date()), 3000);
    return () => clearInterval(t);
  }, []);

  const fallingCount = ALL_COMMODITIES.filter(c => (effectivePrices[c.name]||{}).falling).length;
  const risingCount  = ALL_COMMODITIES.length - fallingCount;
  const avgMape      = (ALL_COMMODITIES.reduce((s, c) => s + c.mape, 0) / ALL_COMMODITIES.length).toFixed(1);

  const visibleList = useMemo(() => {
    let list = activeTab === 'All' ? ALL_COMMODITIES : ALL_COMMODITIES.filter(c => c.cat === activeTab);
    if (search.trim()) list = list.filter(c => c.name.toLowerCase().includes(search.toLowerCase()));
    return list;
  }, [activeTab, search]);

  const heroH=420, botH=130, totalH=heroH+10+botH;
  const rx=0.015, ry=0.043;
  const heroPath=`M ${rx},0 L ${1-rx},0 Q 1,0 1,${ry} L 1,${0.7-ry} Q 1,0.7 ${1-rx},0.7 L ${0.5+rx},0.7 Q 0.5,0.7 0.5,${0.7+ry} L 0.5,${1-ry} Q 0.5,1 ${0.5-rx},1 L ${rx},1 Q 0,1 0,${1-ry} L 0,${0.8+ry} Q 0,0.8 ${rx},0.8 L ${0.2-rx},0.8 Q 0.2,0.8 0.2,${0.8-ry} L 0.2,${0.6+ry} Q 0.2,0.6 ${0.2-rx},0.6 L ${rx},0.6 Q 0,0.6 0,${0.6-ry} L 0,${ry} Q 0,0 ${rx},0 Z`.replace(/\s+/g,' ').trim();

  const heroStats = [
    { label:'Commodities', val:`${ALL_COMMODITIES.length}` },
    { label:'Avg MAPE',    val:`${avgMape}%` },
    { label:'States',      val:'36+FCT' },
    { label:'Falling Now', val:`${fallingCount}` },
    { label:'Rising Now',  val:`${risingCount}` },
  ];

  const STAT_DATA = [
    { value:ALL_COMMODITIES.length, label:'Commodities',
      icon:<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--gold)" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg> },
    { value:ALL_COMMODITIES.length, label:'Models',
      icon:<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--gold)" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg> },
    { value:`${avgMape}%`, label:'Avg MAPE',
      icon:<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--gold)" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg> },
    { value:'24 yrs', label:'Data',
      icon:<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--gold)" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg> },
  ];

  /* ── ICONS (fixed) ── */
  /* Donut icon */
  const IconDonut = (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <circle cx="12" cy="12" r="4"/>
      <path d="M12 2a10 10 0 0 1 7.07 2.93"/>
    </svg>
  );
  /* Sideways / horizontal bar chart icon */
  const IconHBar = (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="3" y1="5"  x2="3"  y2="19"/>
      <line x1="3" y1="7"  x2="19" y2="7"/>
      <line x1="3" y1="12" x2="15" y2="12"/>
      <line x1="3" y1="17" x2="11" y2="17"/>
    </svg>
  );
  /* Vertical bar chart icon (proper columns, NOT waveform) */
  const IconVBar = (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3"  y="13" width="4" height="8" rx="1"/>
      <rect x="10" y="7"  width="4" height="14" rx="1"/>
      <rect x="17" y="3"  width="4" height="18" rx="1"/>
      <line x1="1" y1="21" x2="23" y2="21"/>
    </svg>
  );

  return (
    <div style={{ background:'var(--bg)', minHeight:'100vh' }}>
      <style>{`
        :root {
          --bg:#f4f6f8; --white:#fff;
          --green-900:#0a2e14; --green-700:#15803d;
          --gold:#d4a017; --gold-light:#f0c040;
          --slate-50:#f8fafc; --slate-100:#f1f5f9; --slate-200:#e2e8f0;
          --slate-400:#94a3b8; --slate-500:#64748b; --slate-600:#475569;
          --slate-700:#334155; --slate-800:#1e293b; --slate-900:#0f172a;
          --font-head:'Syne',sans-serif; --mono:'IBM Plex Mono',monospace;
        }
        @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;500;600;700&family=Syne:wght@400;600;700;800&display=swap');
        *{box-sizing:border-box}
        @keyframes fadeInUp{from{opacity:0;transform:translateY(18px)}to{opacity:1;transform:translateY(0)}}
        @keyframes lticker{0%{transform:translateX(0)}100%{transform:translateX(-50%)}}
        @keyframes lpulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.5;transform:scale(1.3)}}
        @keyframes mobIconUp{0%,35%{transform:translateY(0);opacity:1}45%{transform:translateY(-12px);opacity:0}46%,74%{transform:translateY(12px);opacity:0}80%,100%{transform:translateY(0);opacity:1}}
        @keyframes mobLabelIn{0%,40%{opacity:0;transform:translateY(4px)}50%,70%{opacity:1;transform:translateY(0)}80%,100%{opacity:0;transform:translateY(-4px)}}
        .cscroll{overflow-y:auto;scrollbar-width:thin;scrollbar-color:rgba(10,46,20,.12) transparent}
        .cscroll::-webkit-scrollbar{width:3px}
        .cscroll::-webkit-scrollbar-thumb{background:rgba(10,46,20,.12);border-radius:2px}
        .col-scroll{overflow-y:auto;overflow-x:hidden;scrollbar-width:thin;scrollbar-color:rgba(10,46,20,.12) transparent}
        .col-scroll::-webkit-scrollbar{width:3px}
        .col-scroll::-webkit-scrollbar-thumb{background:rgba(10,46,20,.12);border-radius:2px}
        .col-scroll>*{min-width:0}
        .ctab{display:inline-flex;align-items:center;padding:5px 12px;border-radius:6px;font-size:10px;font-weight:700;cursor:pointer;border:none;transition:all .15s;font-family:var(--font-head);flex-shrink:0;letter-spacing:.04em;text-transform:uppercase}
        .ctab.on{background:var(--green-900);color:#fff;box-shadow:0 2px 8px rgba(10,46,20,.28)}
        .ctab:not(.on){background:#fff;color:var(--slate-600);border:1.5px solid var(--slate-200)}
        .ctab:not(.on):hover{border-color:var(--green-700);color:var(--green-700)}
        .search-wrap{display:flex;align-items:center;gap:8px;background:var(--slate-50);border-radius:9px;border:1.5px solid var(--slate-200);padding:8px 13px;transition:border-color .15s}
        .search-wrap:focus-within{border-color:var(--green-700)}
        .search-inp{flex:1;border:none;background:transparent;font-size:13px;color:var(--slate-700);outline:none;font-family:var(--font-head)}
        .search-inp::placeholder{color:var(--slate-400)}
        .watch-dropdown::-webkit-scrollbar{width:3px}
        .watch-dropdown::-webkit-scrollbar-thumb{background:rgba(10,46,20,.15);border-radius:2px}
      `}</style>

      <AppNav activePage="home" priceMode={priceMode} onModeToggle={onModeToggle} onNavigate={onNavigate} isMobile={isMobile} user={user} onUserChange={onUserChange}/>
      <div style={{ height: isMobile ? 60 : 72 }}/>

      <main style={{ maxWidth:1340, margin:'0 auto', padding:isMobile?'0.75rem':'1.25rem 1.5rem', display:'flex', flexDirection:'column', gap:'1rem' }}>

        {/* HERO */}
        {isMobile ? (
          <div style={{ animation:'fadeInUp .8s ease both' }}>
            <div style={{ borderRadius:22, overflow:'hidden', position:'relative', height:290 }}>
              <img src="https://images.unsplash.com/photo-1542838132-92c53300491e?w=1200&q=80" alt="market" style={{ width:'100%', height:'100%', objectFit:'cover', display:'block' }}/>
              <div style={{ position:'absolute', inset:0, background:'linear-gradient(170deg,rgba(10,46,20,.92),rgba(5,30,10,.5) 60%,rgba(0,0,0,.2))' }}/>
              <div style={{ position:'absolute', inset:0, padding:'1.5rem', display:'flex', flexDirection:'column', justifyContent:'flex-end' }}>
                <h1 style={{ fontFamily:'var(--font-head)', fontSize:'clamp(22px,7vw,34px)', fontWeight:800, color:'#fff', lineHeight:1.1, marginBottom:'.5rem', letterSpacing:'-.5px' }}>
                  Welcome to<br/><span style={{ color:'var(--gold-light)' }}>NaijaAgro Predict.</span>
                </h1>
                <p style={{ color:'rgba(255,255,255,.72)', fontSize:12, lineHeight:1.5, marginBottom:'1rem' }}>Track and forecast Nigerian agricultural prices · XGBoost · 24 yrs WFP data</p>
                <button onClick={onPredictClick} onPointerDown={triggerRipple} className="ripple-host"
                  style={{ background:'var(--gold)', border:'none', borderRadius:25, display:'inline-flex', alignItems:'center', gap:8, padding:'10px 22px', cursor:'pointer', fontFamily:'var(--font-head)', fontWeight:700, fontSize:13, color:'var(--green-900)', alignSelf:'flex-start', boxShadow:'0 4px 24px rgba(212,160,23,.5)' }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--green-900)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
                  Predict Prices
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div style={{ position:'relative', height:totalH, animation:'fadeInUp .8s ease both' }}>
            <svg width="0" height="0" style={{ position:'absolute', overflow:'hidden', pointerEvents:'none' }} aria-hidden="true">
              <defs><clipPath id="hsc" clipPathUnits="objectBoundingBox"><path d={heroPath}/></clipPath></defs>
            </svg>
            <div style={{ position:'absolute', top:0, left:0, right:0, height:heroH, clipPath:'url(#hsc)', WebkitClipPath:'url(#hsc)' }}>
              <img src="https://images.unsplash.com/photo-1542838132-92c53300491e?w=1600&q=90" alt="market" style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover', zIndex:0 }}/>
              <div style={{ position:'absolute', inset:0, background:'linear-gradient(135deg,rgba(10,46,20,.82),rgba(5,30,10,.3))', zIndex:1 }}/>
              <div style={{ position:'absolute', top:'10%', left:'5%', zIndex:2, color:'#fff', maxWidth:'46%' }}>
                <h1 style={{ fontFamily:'var(--font-head)', fontSize:'clamp(26px,3.8vw,52px)', fontWeight:700, color:'#fff', lineHeight:1.1, marginBottom:'.75rem', letterSpacing:'-.5px' }}>
                  Welcome to<br/><span style={{ color:'var(--gold-light)' }}>NaijaAgro Predict.</span>
                </h1>
                <p style={{ color:'rgba(255,255,255,.72)', fontSize:14, lineHeight:1.6 }}>Track, analyze and forecast Nigerian agricultural food prices. Powered by XGBoost ML models trained on 24 years of WFP market data.</p>
              </div>
            </div>
            <div style={{ position:'absolute', bottom:'40%', left:'-1%', width:'21%', height:'15%', display:'flex', alignItems:'center', justifyContent:'center', padding:8 }}>
              <button onClick={onPredictClick} onPointerDown={triggerRipple} className="ripple-host"
                style={{ width:'100%', height:'100%', background:'var(--gold)', border:'none', borderRadius:25, display:'flex', alignItems:'center', justifyContent:'center', gap:8, cursor:'pointer', transition:'all .2s', boxShadow:'0 4px 18px rgba(212,160,23,.4)' }}
                onMouseEnter={e => { e.currentTarget.style.background='var(--gold-light)'; e.currentTarget.style.transform='scale(1.03)'; }}
                onMouseLeave={e => { e.currentTarget.style.background='var(--gold)'; e.currentTarget.style.transform='scale(1)'; }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--green-900)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink:0 }}><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
                <span style={{ fontFamily:'var(--font-head)', fontWeight:700, fontSize:13, color:'var(--green-900)', whiteSpace:'nowrap' }}>Predict</span>
              </button>
            </div>
            <div style={{ position:'absolute', bottom:'25%', left:'51%', height:'20%', width:'49%', background:'var(--green-900)', borderRadius:16, display:'flex', alignItems:'stretch', overflow:'hidden' }}>
              {heroStats.map((s, i) => (
                <div key={i} style={{ flex:1, display:'flex', flexDirection:'column', justifyContent:'center', padding:'0 .9rem', gap:3, borderLeft:i>0?'1px solid rgba(255,255,255,.09)':'none' }}>
                  <span style={{ fontSize:9, textTransform:'uppercase', letterSpacing:'.06em', color:'rgba(255,255,255,.4)', fontWeight:500 }}>{s.label}</span>
                  <span style={{ fontFamily:'var(--font-head)', fontSize:13, fontWeight:700, color:'#fff' }}>{s.val}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* TICKER */}
        <Ticker prices={effectivePrices}/>

        {/* 3-COLUMN LAYOUT (desktop) */}
        {!isMobile ? (
          <div style={{ display:'grid', gridTemplateColumns:'260px 1fr 310px', gap:'1rem', alignItems:'start', height:'calc(100vh - 88px)', overflow:'hidden' }}>

            {/* LEFT COLUMN */}
            <div className="col-scroll" style={{ height:'100%' }}>
              <div style={{ display:'flex', flexDirection:'column', gap:'0.6rem', padding:'0 0 1rem' }}>

                {/* Stat boxes */}
                <div style={{ background:'#fff', borderRadius:14, border:'1px solid var(--slate-200)', padding:'10px 8px', boxShadow:'0 2px 10px rgba(0,0,0,0.04)', flexShrink:0 }}>
                  <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:4 }}>
                    {STAT_DATA.map((s, i) => (
                      <div key={i} style={{ background:'var(--slate-50)', borderRadius:8, padding:'7px 4px', textAlign:'center', border:'1px solid var(--slate-100)' }}>
                        <div style={{ fontSize:12, fontWeight:700, color:'var(--slate-800)', fontFamily:'var(--font-head)', lineHeight:1 }}>{s.value}</div>
                        <div style={{ marginTop:3, display:'flex', justifyContent:'center' }}>{s.icon}</div>
                        <div style={{ fontSize:7, color:'var(--slate-400)', marginTop:2, fontFamily:'var(--mono)', textTransform:'uppercase', letterSpacing:'.04em' }}>{s.label}</div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Chart panel — icon strip narrowed, minHeight raised */}
                <div style={{
                  background: '#fff', borderRadius: 14, border: '1px solid var(--slate-200)',
                  overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.04)',
                  display: 'flex',
                  minHeight: 300,   /* was 260 */
                }}>
                  {/* ↓ icon strip: width 42 (was 46) */}
                  <div style={{
                    width: 42, borderRight: '1px solid var(--slate-100)',
                    display: 'flex', flexDirection: 'column', alignItems: 'center',
                    justifyContent: 'center', gap: 10, padding: '12px 0',
                    flexShrink: 0, background: 'var(--slate-50)',
                  }}>
                    {/* Donut icon — 16×16 (was 18×18) */}
                    <NavBtn
                      icon={
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="12" cy="12" r="10"/>
                          <circle cx="12" cy="12" r="4"/>
                          <path d="M12 2a10 10 0 0 1 7.07 2.93"/>
                        </svg>
                      }
                      label="MAPE Donut"
                      active={activeChart === 'donut'}
                      onClick={() => setActiveChart('donut')}
                    />
                    {/* Horizontal bar chart icon — 16×16 */}
                    <NavBtn
                      icon={
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <line x1="3" y1="5"  x2="3"  y2="19"/>
                          <line x1="3" y1="7"  x2="19" y2="7"/>
                          <line x1="3" y1="12" x2="15" y2="12"/>
                          <line x1="3" y1="17" x2="11" y2="17"/>
                        </svg>
                      }
                      label="Price Comparison"
                      active={activeChart === 'bar'}
                      onClick={() => setActiveChart('bar')}
                    />
                    {/* Vertical bar chart icon — 16×16 */}
                    <NavBtn
                      icon={
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="3"  y="13" width="4" height="8" rx="1"/>
                          <rect x="10" y="7"  width="4" height="14" rx="1"/>
                          <rect x="17" y="3"  width="4" height="18" rx="1"/>
                          <line x1="1" y1="21" x2="23" y2="21"/>
                        </svg>
                      }
                      label="All Commodities"
                      active={activeChart === 'allchart'}
                      onClick={() => setActiveChart('allchart')}
                    />
                  </div>

                  {/* Chart content area */}
                  <div style={{ flex: 1, padding: '10px 8px', minWidth: 0, overflow: 'hidden' }}>
                    {activeChart === 'donut'    && <DonutChart />}
                    {activeChart === 'bar'      && <PriceBarChart prices={effectivePrices} />}
                    {activeChart === 'allchart' && <AllCommoditiesChart prices={effectivePrices} />}
                  </div>
                </div>

                {/* Watchlist — professional pin + commodity selector */}
                <WatchlistPanel isLive={isLive} effectivePrices={effectivePrices}/>

              </div>
            </div>

            {/* CENTER COLUMN */}
            <div className="col-scroll" style={{ height:'100%', display:'flex', flexDirection:'column', gap:'1rem', paddingRight:4 }}>
              <div style={{ background:'#fff', borderRadius:14, border:'1px solid var(--slate-200)', overflow:'hidden', boxShadow:'0 2px 14px rgba(0,0,0,0.05)', display:'flex', flexDirection:'column' }}>
                <div style={{ padding:'12px 16px 0' }}>
                  <div className="search-wrap" style={{ marginBottom:10 }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--slate-400)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                    <input className="search-inp" type="text" placeholder="Search commodity..." value={search} onChange={e => setSearch(e.target.value)}/>
                    {search && <button onClick={() => setSearch('')} style={{ background:'none', border:'none', cursor:'pointer', color:'var(--slate-400)', padding:0, lineHeight:1, fontSize:14 }}>&#10005;</button>}
                  </div>
                  <div style={{ display:'flex', gap:5, overflowX:'auto', paddingBottom:12, scrollbarWidth:'none' }}>
                    {CATS.map(t => <button key={t} className={`ctab${activeTab===t?' on':''}`} onClick={() => setActiveTab(t)}>{t}</button>)}
                  </div>
                </div>
                <div style={{ display:'flex', alignItems:'center', padding:'7px 12px', background:'var(--green-900)', gap:10 }}>
                  <div style={{ width:18, fontSize:9, fontWeight:700, color:'rgba(212,160,23,0.5)', fontFamily:'var(--mono)', textAlign:'right', flexShrink:0 }}>#</div>
                  <div style={{ width:40, flexShrink:0 }}/>
                  <div style={{ flex:1, fontSize:10, fontWeight:700, color:'var(--gold)', fontFamily:'var(--font-head)', textTransform:'uppercase', letterSpacing:'.08em' }}>Commodity</div>
                  <div style={{ width:58, fontSize:10, fontWeight:700, color:'var(--gold)', fontFamily:'var(--font-head)', textTransform:'uppercase', letterSpacing:'.08em', textAlign:'center', flexShrink:0 }}>Conf.</div>
                  <div style={{ width:90, fontSize:10, fontWeight:700, color:'var(--gold)', fontFamily:'var(--font-head)', textTransform:'uppercase', letterSpacing:'.08em', textAlign:'right', flexShrink:0 }}>Price (₦)</div>
                  <div style={{ width:30, flexShrink:0 }}/>
                </div>
                <div style={{ overflowY:'auto', flex:1, scrollbarWidth:'thin', scrollbarColor:'rgba(10,46,20,.12) transparent' }}>
                  {visibleList.length === 0 ? (
                    <div style={{ padding:'2.5rem', textAlign:'center', color:'var(--slate-400)', fontSize:13, fontFamily:'var(--font-head)' }}>No results for "{search}"</div>
                  ) : visibleList.map((c, idx) => (
                    <CommodityRow key={c.name} c={c} rowNum={idx + 1}
                      pd={effectivePrices[c.name]||{price:c.base,pct:'0.00',falling:c.trend===-1}}
                      onPredict={(name) => onNavigate('predict', { initialCommodity: name })}/>
                  ))}
                </div>
                <div style={{ padding:'8px 16px', borderTop:'1px solid var(--slate-100)', display:'flex', justifyContent:'space-between', alignItems:'center', background:'var(--slate-50)', flexShrink:0 }}>
                  <div style={{ fontSize:10, color:'var(--slate-500)' }}>
                    <span style={{ color:'#2563eb', fontWeight:700 }}>{fallingCount} falling</span>
                    {' · '}
                    <span style={{ color:'#dc2626', fontWeight:700 }}>{risingCount} rising</span>
                    {' · '}{lastUpdate.toLocaleTimeString()}
                  </div>
                  <div style={{ fontSize:10, color:'var(--slate-400)' }}>{visibleList.length} / {ALL_COMMODITIES.length}</div>
                </div>
              </div>

              <footer style={{ background:'linear-gradient(135deg,var(--green-900),#051a0b)', color:'#fff', padding:'1.25rem 1.5rem', borderRadius:14, border:'1px solid rgba(212,160,23,.12)', boxShadow:'0 4px 20px rgba(10,46,20,.18)', flexShrink:0 }}>
                <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'.45rem' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:8, fontFamily:'var(--font-head)', fontWeight:700, fontSize:14 }}>
                    <div style={{ width:26, height:26, borderRadius:'50%', background:'var(--gold)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#0a2e14" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2C8 2 4 7 4 12s3 8 8 10c5-2 8-5 8-10S16 2 12 2z"/><path d="M12 6v6l4 2"/></svg>
                    </div>
                    NaijaAgro Predict
                  </div>
                  <div style={{ display:'flex', gap:'1rem', fontSize:11, flexWrap:'wrap', justifyContent:'center' }}>
                    {[['About','about'],['Terms','terms'],['Privacy','privacy']].map(([lbl,pg]) => (
                      <button key={pg} onClick={() => onNavigate(pg)} style={{ background:'transparent', border:'none', color:'rgba(255,255,255,.7)', cursor:'pointer', padding:0, font:'inherit', transition:'color .2s' }}
                        onMouseEnter={e => e.currentTarget.style.color='var(--gold)'}
                        onMouseLeave={e => e.currentTarget.style.color='rgba(255,255,255,.7)'}>{lbl}</button>
                    ))}
                    <a href="https://api.vam.wfp.org/dataviz/v1/charts/mkt-prices?adm0Code=181" target="_blank" rel="noreferrer"
                      style={{ color:'rgba(255,255,255,.7)', textDecoration:'none' }}
                      onMouseEnter={e => e.currentTarget.style.color='var(--gold)'}
                      onMouseLeave={e => e.currentTarget.style.color='rgba(255,255,255,.7)'}>API Docs</a>
                  </div>
                  <div style={{ fontSize:9, color:'rgba(255,255,255,.3)', textAlign:'center' }}>2026 MOUAU Student Project · XGBoost + WFP Data · {ALL_COMMODITIES.length} models</div>
                </div>
              </footer>
            </div>

            {/* RIGHT COLUMN */}
            <div className="col-scroll" style={{ height:'100%' }}>
              <div style={{ display:'flex', flexDirection:'column', gap:'0.5rem', padding:'0 0 1rem' }}>

                <div style={{ display:'flex', justifyContent:'flex-end', gap:6 }}>
                  <RightIconBtn active={rightView==='map'||rightView==='candle'||rightView==='detail'} label="Map" onClick={() => setRightView('map')}
                    icon={<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"/><line x1="8" y1="2" x2="8" y2="18"/><line x1="16" y1="6" x2="16" y2="22"/></svg>}
                  />
                  <RightIconBtn active={false} label="Predict" onClick={onPredictClick}
                    icon={<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>}
                  />
                </div>

                {/* Main right panel */}
                <div style={{ background:'#fff', borderRadius:14, border:'1px solid var(--slate-200)', overflow:'hidden', boxShadow:'0 2px 14px rgba(0,0,0,0.06)' }}>

                  {rightView==='map' && (
                    <div style={{ display:'flex', flexDirection:'column' }}>
                      <NigeriaMapWithFlag
                        onPredictClick={onPredictClick}
                        onStateClick={s => {
                          setSelectedState(s);
                          setRightOhlc(genOHLC(35000 + Math.random() * 30000));
                          setRightView('candle');
                        }}
                      />
                      <div style={{ display:'flex', alignItems:'center', gap:7, padding:'8px 12px', borderTop:'1px solid var(--slate-100)' }}>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--slate-400)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"/><path d="M13 13l6 6"/>
                        </svg>
                        <span style={{ fontSize:10, color:'var(--slate-500)', lineHeight:1.4 }}>Click any state to view price chart</span>
                      </div>
                    </div>
                  )}

                  {rightView==='candle' && selectedState && (
                    <div style={{ display:'flex', flexDirection:'column' }}>
                      <div style={{ padding:'8px 12px', borderBottom:'1px solid var(--slate-100)', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                        <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                          <button onClick={() => setRightView('map')} style={{ background:'none', border:'none', cursor:'pointer', color:'var(--slate-500)', display:'flex', alignItems:'center', gap:4, fontSize:11, fontFamily:'var(--font-head)' }}>
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>
                            Map
                          </button>
                          <span style={{ width:7, height:7, borderRadius:'50%', background:'#22c55e', display:'inline-block', animation:'lpulse 2s infinite' }}/>
                          <span style={{ fontSize:12, fontWeight:700, color:'var(--slate-800)', fontFamily:'var(--font-head)' }}>{selectedState}</span>
                        </div>
                        <button onClick={() => setRightView('detail')}
                          style={{ padding:'3px 9px', borderRadius:6, border:'none', cursor:'pointer', background:'var(--slate-100)', color:'var(--slate-600)', fontSize:10, fontWeight:700, fontFamily:'var(--font-head)', display:'flex', alignItems:'center', gap:4 }}>
                          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>
                          Detail
                        </button>
                      </div>
                      <div style={{ padding:'4px 4px 2px' }}>
                        <InteractiveCandlestick
                          commodity={selectedState}
                          unit="/50kg"
                          basePrice={rightOhlc[0]?.open || 42800}
                          isLiveMode={isLive}
                        />
                      </div>
                    </div>
                  )}

                  {rightView==='detail' && selectedState && (
                    <RightDetailView
                      state={selectedState}
                      ohlc={rightOhlc}
                      onBack={() => setRightView('candle')}
                      onPredict={onPredictClick}
                      prices={effectivePrices}
                    />
                  )}
                </div>
              </div>
            </div>

          </div>
        ) : (
          /* MOBILE */
          <div style={{ display:'flex', flexDirection:'column', gap:'1rem' }}>
            <div style={{ display:'flex', gap:8, overflowX:'auto', paddingBottom:4 }}>
              {[
                {
                  id:'donut', label:'MAPE Donut',
                  icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="4"/><path d="M12 2a10 10 0 0 1 7.07 2.93"/></svg>,
                },
                {
                  id:'bar', label:'Price Chart',
                  /* sideways / horizontal bar chart icon */
                  icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="5" x2="3" y2="19"/><line x1="3" y1="7" x2="19" y2="7"/><line x1="3" y1="12" x2="15" y2="12"/><line x1="3" y1="17" x2="11" y2="17"/></svg>,
                },
                {
                  id:'allchart', label:'All Commod.',
                  /* vertical bar chart icon (proper bars, NOT waveform) */
                  icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="13" width="4" height="8" rx="1"/><rect x="10" y="7" width="4" height="14" rx="1"/><rect x="17" y="3" width="4" height="18" rx="1"/><line x1="1" y1="21" x2="23" y2="21"/></svg>,
                },
              ].map((b, i) => (
                <button key={b.id} onClick={() => setActiveChart(b.id)}
                  style={{ position:'relative', width:52, height:52, borderRadius:13, border:'none', cursor:'pointer', flexShrink:0, background:activeChart===b.id?'var(--green-900)':'#fff', color:activeChart===b.id?'var(--gold)':'var(--slate-500)', overflow:'hidden', boxShadow:activeChart===b.id?'0 2px 10px rgba(10,46,20,.3)':'0 1px 4px rgba(0,0,0,0.06)' }}>
                  <div style={{ position:'absolute', inset:0, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center' }}>
                    <div style={{ animation:`mobIconUp 4s ease infinite`, animationDelay:`${i*1.3}s` }}>{b.icon}</div>
                    <div style={{ position:'absolute', bottom:7, fontSize:7, fontWeight:700, fontFamily:'var(--font-head)', animation:`mobLabelIn 4s ease infinite`, animationDelay:`${i*1.3}s`, opacity:0, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', maxWidth:48, textTransform:'uppercase', letterSpacing:'.03em' }}>
                      {b.label.split(' ')[0]}
                    </div>
                  </div>
                </button>
              ))}
            </div>

            {activeChart==='donut'    && <DonutChart/>}
            {activeChart==='bar'      && <PriceBarChart prices={effectivePrices}/>}
            {activeChart==='allchart' && <AllCommoditiesChart prices={effectivePrices}/>}

            <div style={{ background:'#fff', borderRadius:14, border:'1px solid var(--slate-200)', overflow:'hidden' }}>
              <div style={{ padding:'10px 12px 0' }}>
                <div className="search-wrap" style={{ marginBottom:8 }}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--slate-400)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                  <input className="search-inp" type="text" placeholder="Search commodity..." value={search} onChange={e => setSearch(e.target.value)}/>
                </div>
                <div style={{ display:'flex', gap:5, overflowX:'auto', paddingBottom:10, scrollbarWidth:'none' }}>
                  {CATS.map(t => <button key={t} className={`ctab${activeTab===t?' on':''}`} onClick={() => setActiveTab(t)}>{t}</button>)}
                </div>
              </div>
              <div style={{ borderTop:'1px solid var(--slate-100)' }}>
                {visibleList.map((c, idx) => (
                  <CommodityRow key={c.name} c={c} rowNum={idx+1}
                    pd={effectivePrices[c.name]||{price:c.base,pct:'0.00',falling:c.trend===-1}}
                    onPredict={(name) => onNavigate('predict', { initialCommodity: name })}/>
                ))}
              </div>
            </div>

            {/* Mobile watchlist with pin system */}
            <WatchlistPanel isLive={isLive} effectivePrices={effectivePrices}/>

            <div style={{ borderRadius:14, overflow:'hidden', border:'1px solid var(--slate-200)' }}>
              <NigeriaMapWithFlag onPredictClick={onPredictClick}/>
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:7, padding:'7px 10px', background:'#fff', borderRadius:9, border:'1px solid var(--slate-100)' }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--slate-400)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"/><path d="M13 13l6 6"/></svg>
              <span style={{ fontSize:10, color:'var(--slate-500)' }}>Click on a state on the map to view price prediction</span>
            </div>

            <footer style={{ background:'linear-gradient(135deg,var(--green-900),#051a0b)', color:'#fff', padding:'1.25rem', borderRadius:14, border:'1px solid rgba(212,160,23,.12)' }}>
              <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'.4rem' }}>
                <div style={{ fontFamily:'var(--font-head)', fontWeight:700, fontSize:14 }}>NaijaAgro Predict</div>
                <div style={{ display:'flex', gap:'.9rem', fontSize:11, flexWrap:'wrap', justifyContent:'center' }}>
                  {['about','terms','privacy'].map(pg => (
                    <button key={pg} onClick={() => onNavigate(pg)} style={{ background:'transparent', border:'none', color:'rgba(255,255,255,.7)', cursor:'pointer', padding:0, font:'inherit', textTransform:'capitalize' }}>{pg}</button>
                  ))}
                </div>
                <div style={{ fontSize:9, color:'rgba(255,255,255,.3)', textAlign:'center' }}>2026 MOUAU Student Project · {ALL_COMMODITIES.length} models</div>
              </div>
            </footer>
          </div>
        )}
      </main>
    </div>
  );
}